import React from "react";
import { Link } from "react-router-dom";

import { Logo } from "../../components";

import Button from "../../components/Button";
import * as S from "./styles";

export const Index = () => {
  return (
    <S.Container>
      <S.Banner.Wrapper>
        <Logo color="white" />

        <S.Banner.Content>
          <S.Banner.Title>
            Credenciamento
            <br />
            de Estipulante
          </S.Banner.Title>
          <S.Banner.Logo />
        </S.Banner.Content>
      </S.Banner.Wrapper>

      <S.Content>
        <S.Text>
          Este credenciamento habilita seu parceiro de negócio a operação com os
          produtos: Seguro Imobiliária Residencial, Seguro Imobiliária Não
          Residencial e Porto Seguro Aluguel com fatura mensal.
          <br />
          <br />
          Eu corretor declaro ter autorização para solicitar o credenciamento de
          parceiros de negócios junto a Porto, assumo inteira responsabilidade,
          sob as penas da lei, pelas informações prestadas e declaro ciência, de
          que com base na distribuição legal das responsabilidades, a Porto
          Seguro poderá me acionar juridicamente, se necessário, para garantir
          seu direito de ressarcimento por penalidades eventualmente sofridas,
          em função de inconsistências e ou manipulações de informações
          disponibilizadas.
        </S.Text>

        <Link to="/cadastro">
          <Button icon="Check">Li e estou de acordo com os termos</Button>
        </Link>
      </S.Content>
    </S.Container>
  );
};
